import { categoryApi } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

/**
 * RTK Query API slice for categories
 */
export const categoriesApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCategories: builder.query({
      query: () => ({
        url: categoryApi(),
        method: 'POST',
        body: { method: 'read', data: {} },
      }),
      transformResponse: (response) => response.data,
    }),
    getStoreCategories: builder.query({
      query: (store) => ({
        url: categoryApi(),
        method: 'POST',
        body: { method: 'listCategoryByUsername', data: { name: store } },
      }),
      transformResponse: (response) => response.data,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAllCategoriesQuery,
  useGetStoreCategoriesQuery,
} = categoriesApi; 